import { createI18n } from 'vue-i18n'
import ru from './ru'
import uz from './uz'

export const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  locale: localStorage.getItem('locale') || 'ru',
  fallbackLocale: 'ru',
  messages: {
    ru,
    uz,
  },
})
